import React from 'react';
import { useTranslation, Trans } from 'react-i18next';
import { Container, Row, Col } from 'react-bootstrap';
import styles from './LearnTheoryExam.module.css';
import { PageTitle } from '../../ui-components/PageTitle/PageTitle';
import { LinkWrapper } from '../../ui-components/LinkWrapper/LinkWrapper';
import SeoLinks from '../../components/SeoLinks/SeoLinks';

const LearnTheoryExam = () => {
  const { t } = useTranslation();

  return (
    <div className={styles.root}>
      <Container>
        <Row>
          <Col>
            <PageTitle>{t('learnTheoryExam.title1')}</PageTitle>
          </Col>
        </Row>

        <Row>
          <Col>
            <div className={styles.text}>
              <div>
                <Trans i18nKey="learnTheoryExam.text11">
                  desc
                  <LinkWrapper to="/about">für die Theorieprüfung lernen</LinkWrapper>
                  desc
                  <LinkWrapper to="/">theorie24.ch</LinkWrapper>
                  desc
                </Trans>
              </div>
              <div>{t('learnTheoryExam.text12')}</div>
            </div>
          </Col>
        </Row>

        <Row>
          <Col>
            <div className={styles.subtitle}>{t('learnTheoryExam.title2')}</div>
          </Col>
        </Row>

        <Row>
          <Col>
            <div className={styles.text}>
              <Trans i18nKey="learnTheoryExam.text2">
                desc
                <LinkWrapper to="/">theorie24.ch</LinkWrapper>
                desc
              </Trans>
            </div>
          </Col>
        </Row>

        <Row>
          <Col>
            <div className={styles.subtitle}>{t('learnTheoryExam.title3')}</div>
          </Col>
        </Row>

        <Row>
          <Col>
            <div className={styles.text}>
              <Trans i18nKey="learnTheoryExam.text3">
                desc
                <LinkWrapper to="/offers">Registrieren</LinkWrapper>
                desc
              </Trans>
            </div>
          </Col>
        </Row>

        <Row className={styles.links}>
          <SeoLinks />
        </Row>
      </Container>
    </div>
  );
};

export default LearnTheoryExam;
